import api from './api';

export function getGrupos() {
    return api.get('/grupos_pequenos');
}

export function getGrupoById(idGrupoPequeno) {
    return api.get(`/grupos_pequenos/${idGrupoPequeno}`);
}

export function atualizarGrupo(idGrupoPequeno, grupo) {
    return api.put(`grupos_pequenos/${idGrupoPequeno}`, grupo);
}

export function getMembrosByGrupo(idGrupoPequeno) {
    return api.get(`/grupos_pequenos/${idGrupoPequeno}/membros_completo`);
}

export function getMembrosByNome(nome) {
    return api.get(`senib/alunos/buscar/${nome}`);
}

export function adicionarMembroAoGrupo(idAluno, idGrupoPequeno) {
    return api.put(`alunos/${idAluno}/associar_grupo`, {
        id_grupo_pequeno: idGrupoPequeno,
    });
}

export function cadastrarMembro(membro) {
    return api.post(`membros`, membro);
}

export function cadastrarCrianca(crianca) {
    return api.post(`criancas`, crianca);
}

export function atualizaCriancas(idCrianca, membro) {
    return api.put(`criancas/${idCrianca}`, membro);
}
export function getCriancasById(idCrianca) {
    return api.get(`criancas/${idCrianca}`);
}

export function deletarCrianca(idCrianca) {
    return api.delete(`criancas/${idCrianca}`);
}

export function atualizarMembro(idMembro, membro) {
    return api.put(`membros/${idMembro}`, membro);
}

export function getMembroById(idMembro) {
    return api.get(`membros/${idMembro}`);
}

export function getPalavraFest(idGrupoPequeno, semana) {
    return api.get(`grupos_pequenos/${idGrupoPequeno}/palavra_fest`, {
        params: {
            semana,
        },
    });
}

export function getDesafioMeditacao(idGrupoPequeno) {
    return api.get(
        `grupos_pequenos/${idGrupoPequeno}/palavra_fest_desafio_meditacao`
    );
}

export function getMemorizacaoCompleta(idGrupoPequeno) {
    return api.get(
        `grupos_pequenos/${idGrupoPequeno}/palavra_fest_memorizacao`
    );
}

export function getPalavraFestCriancas(idMembro, semana) {
    return api.get(`membros/${idMembro}/controle_criancas_palavra_fest`, {
        params: {
            semana,
        },
    });
}

export function salvarItem(idAluno, idItem, situacao) {
    return api.post(`alunos/${idAluno}/palavra_fest/item`, {
        id_item: idItem,
        situacao,
    });
}

export function salvarItemCrianca(idAluno, idItem, situacao) {
    return api.post(`criancas/${idAluno}/palavra_fest/item`, {
        id_item: idItem,
        situacao,
    });
}

export function getCriancasPalavraFest(idMembro) {
    return api.get(`/membros/${idMembro}/criancas_palavra_fest`);
}

export function salvarParticipacaoMembro(idMembro, participa) {
    return api.post(`membros/${idMembro}/palavra_fest/participacao`, {
        participa,
    });
}

export function getEventosGruposPequenos() {
    return api.get('/eventos_grupos_pequenos');
}

export function getSessoesEventosGruposPequenos(idsEventos) {
    return Promise.all(idsEventos.map((id) => api.get(`/eventos_grupos_pequenos/${id}/sessoes`)));
}

export function getFrequenciaEventos(idGrupoPequeno, idsEventos) {
    return api.get(`/grupos_pequenos/${idGrupoPequeno}/frequencia_evento/${idsEventos}`);
}

export function salvarFrequenciaMembro(idMembro, idEvento, idSessao) {
    return api.post(`membros/${idMembro}/frequencia_evento/${idEvento}`, {
        idSessao,
    });
}

export function getPalavraFestStatus() {
    return api.get('/palavra_fest/status');
}

// Controle de Faltas J1 (Nova Jovens 1) - tabela j1_registro
export function getRegistrosJ1(idGrupoPequeno, dtEvento) {
    return api.get(`/grupos_pequenos/${idGrupoPequeno}/j1_registro`, {
        params: {
            dt_evento: dtEvento,
        },
    });
}

export function salvarFaltaJ1(idMembro, idGrupoPequeno, dtEvento, txJustificativa) {
    return api.post(`membros/${idMembro}/j1_registro`, {
        idGrupoPequeno,
        dtEvento,
        txJustificativa,
    });
}

export function removerFaltaJ1(idMembro, idGrupoPequeno, dtEvento) {
    return api.delete(`membros/${idMembro}/j1_registro`, {
        params: {
            id_grupo_pequeno: idGrupoPequeno,
            dt_evento: dtEvento,
        },
    });
}

export function getFaltasAnoJ1(idGrupoPequeno, ano) {
    return api.get(`/grupos_pequenos/${idGrupoPequeno}/j1_registro/ano/${ano}`);
}